import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { createPatient, getPatients } from '../../redux/Patient/PatientAction';
import PatientForm from './PatientForm';
import { useHistory, useParams } from 'react-router-dom';
import useCheckMobileScreen from '../../hooks/useWidth';
import MessagesContext from '../../contexts/messagesContext';
import { AlertDialog, MainDialog } from '../UI';
import LanguageContext from '../../contexts/languageContext';
import useAddPatient from '../AllPatients/AddPatient';
import * as type from '../../redux/Patient/PatientType';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import { getClinicId } from '../../utils/storage';

const styles = makeStyles({
    formContainer: {
        maxWidth: '945px',
        margin: '0 auto'
    }
});
const PatientProfile = () => {
    const classes = styles();
    const loadingSelector = createLoadingSelector(type.GET_PATIENTS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const dispatch = useDispatch();
    const history = useHistory();
    const { clinicId } = useParams();
    const isMobile = useCheckMobileScreen();
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const { dialog, setDialog, goToPatientPage } = useAddPatient();

    const handleSubmitPatient = async (patient) => {
        // const patients = createParam(patient)
        const response = await dispatch(createPatient(patient));
        if (response?.status === 200) {
            goToPatientPage(response.data);
        }
    };

    const searchPatients = async (NID, name) => {
        const params = {
            offset: 0,
            limit: 20,
            name: name,
            nationalId: NID,
            clinic: getClinicId()
        };
        const isHintSearch = true;
        if (NID || name?.trim()) {
            await dispatch(getPatients(params, isHintSearch));
        }
    };

    // const handleCancel = () => {
    //     history.goBack();
    // };

    return isMobile ? (
        <div className={classes.formContainer}>
            <PatientForm
                formType="add"
                loadingPatients={isLoading}
                submitPatient={handleSubmitPatient}
                searchPatients={searchPatients}
                lang={lang}
                // handleCancel={handleCancel}
            />
        </div>
    ) : (
        <MainDialog
            open={true}
            title={messages.newUser}
            goBack={() => {
                history.goBack();
            }}
        >
            <div className={classes.formContainer}>
                <AlertDialog
                    open={dialog}
                    alertText={messages.alerts.warningNumberOfPatients}
                    cancelText={messages.alerts.ok}
                    handleClose={() => {
                        setDialog(false);
                        history.push(`/${clinicId}/patients`);
                    }}
                    primaryCancelButton
                />
                <PatientForm
                    formType="add"
                    loadingPatients={isLoading}
                    submitPatient={handleSubmitPatient}
                    searchPatients={searchPatients}
                    lang={lang}
                    // handleCancel={handleCancel}
                />
            </div>
        </MainDialog>
    );
};
PatientProfile.propTypes = {
    classes: PropTypes.object,
    createPatient: PropTypes.func,
    goBack: PropTypes.func,
    history: PropTypes.any,
    getPatients: PropTypes.func
};

export default PatientProfile;
